// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"29418f07","327":"497dbc2e","429":"5b0dffa9","453":"76c832c2","484":"0259b5cf","551":"b33c52e4"}[chunkId] + ".chunk.js";
};